import React from "react";

function PageHeader({ title }) {
   return (
      <h2 className="font-bold py-4 border-b border-gray-600 mb-8">{title}</h2>
   );
}

export default PageHeader;
